import _get from 'lodash/get';

import { BRAND_IDENTITIES } from '../../../components/modules/foundation/hooks/use-branding/useBranding.constants';
import { FISHERMAN_HELP_CENTER_URL, GLAMMATIC_HELP_CENTER_URL } from '../../../constants/constants';

const HELP_CENTER_URL_BY_BRAND = {
  [BRAND_IDENTITIES.FISHERMAN]: FISHERMAN_HELP_CENTER_URL,
  [BRAND_IDENTITIES.GLAMMATIC]: GLAMMATIC_HELP_CENTER_URL,
};

export function getHelpCenterUrl(brandIdentity) {
  return HELP_CENTER_URL_BY_BRAND[brandIdentity] || FISHERMAN_HELP_CENTER_URL;
}

export function shouldDisplayHelpCenter(state) {
  const branding = _get(state, 'business.core.value.brand_identity');

  return Boolean(HELP_CENTER_URL_BY_BRAND[branding]);
}
